(function () {
  if (window.__wePdpMembershipInfoInit) return;
  window.__wePdpMembershipInfoInit = true;

  const INFO_DETAILS_SELECTOR = '.we-pdp-membership-info, .price__uvp-info';

  const closeOpenInfoPopovers = (except) => {
    document.querySelectorAll(`${INFO_DETAILS_SELECTOR}[open]`).forEach((details) => {
      if (except && details === except) return;
      details.open = false;
    });
  };

  document.addEventListener('click', (event) => {
    document.querySelectorAll(`${INFO_DETAILS_SELECTOR}[open]`).forEach((details) => {
      if (!details.contains(event.target)) {
        details.open = false;
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeOpenInfoPopovers();
    }
  });
})();
